import { Box, Chip, type ChipProps } from '@mui/material'
import { getColorCSS } from '../color/color.js'
import { hashColorName } from '../color/hash-color.js'

export interface TagProps extends ChipProps {
  label: string
}

export const Tag = ({ sx, ...restProps }: TagProps) => {
  const color = getColorCSS(hashColorName(restProps.label))
  return (
    <Box sx={sx}>
      <Chip
        component={'span'}
        sx={{
          marginLeft: 0,
          backgroundColor: color,
          color: theme => theme.palette.getContrastText(color),
        }}
        {...restProps}
      />
    </Box>
  )
}
